import { grayColor, whiteColor } from 'assets/jss/material-dashboard-pro-react';

const loginPageStyle = () => ({
	textCenter: {
		textAlign: 'center',
	},
	justifyContentCenter: {
		justifyContent: 'center !important',
		display: 'block',
		textAlign: 'center',
		marginLeft: 0,
		marginRight: 0,
	},
	footerLinks: {
		marginTop: 64,
		marginBottom: 24,
		'& a': {
			marginLeft: 4,
		},
	},
	customButtonClass: {
		'&,&:focus,&:hover': {
			color: whiteColor,
		},
		marginLeft: '5px',
		marginRight: '5px',
	},
	inputAdornment: {
		marginRight: '18px',
	},
	inputAdornmentIcon: {
		color: grayColor[6],
	},
	cardHeader: {
		marginBottom: '20px',
	},
	socialLine: {
		padding: '0.9375rem 0',
	},
	loginUnsuccessful: {
		marginBottom: 18,
	},
	cardBody: {
		paddingBottom: 54,
		paddingTop: 33,
	},
});

export default loginPageStyle;
